<ng-container *ngIf="role && role !== 'MODERATOR'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as CUSTOMER, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>
<ng-container *ngIf="role && role === 'MODERATOR'">
  <div class="wrapper ">
    <br>
    <div>
      <div class="content">
        <ng-container *ngIf="tickets">
          <div class="alert alert-danger" role="alert" *ngIf="tickets.length === 0">
            No Tickets to Verify
          </div>
          <div class="alert alert-primary" role="alert" *ngIf="tickets.length !== 0">
            Tickets to be Verified/Deleted/Altered
          </div>
          <div class="card">
          <div class="card-body">
            <table class="table table-hover">
              <thead class=" text-primary">
                <tr>
                  <th scope="col">Ticket ID</th>
                  <th scope="col">Message</th>
                  <th scope="col">Created On</th>
                  <th scope="col">Updated On</th>
                  <th scope="col">See Chat</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ticket of tickets">
                  <td>{{ ticket._id }}</td>
                  <!--<td>{{ ticket.moderator.fullName }}</td>
                  <td>
                    <div *ngIf="ticket.techExpert" style="font-weight: bolder;">
                      {{ ticket.techExpert.fullName }}
                    </div>
                    <div *ngIf="!ticket.techExpert" style="font-style: italic;">
                      Your Ticket is yet to be assigned to one of our experts
                    </div>
                  </td>-->
                  <td>{{ ticket.message[0]['message'] }}</td>
                  <td>{{ ticket.createdAt }}</td>
                  <td>{{ ticket.updatedAt }}</td>
                  <!-- <td>
                    <button class="submit" ><mat-icon>question-answer</mat-icon></button>
                  </td> -->
                  <td>
                    <button class="btn btn-lg btn-outline-primary" (click)="open(mymodal, ticket.message, ticket._id)">See Chat</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </ng-container>

        <ng-template #mymodal let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">See your chat with expert</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">×</span>
            </button>
          </div>
            <div class="modal-body">
              <div class="blinking"><p>After sending message<br>Refresh the page for display of reply message !!!</p></div>  

              <div id="container">
                <main>
                  <ul id="chat">
                    <div *ngFor='let message of messages'>
                      <div *ngIf="message.role === 'TECHEXPERT'">
                        <li class="you">
                          <div class="entete">
                            <span class="status green"></span>
                            <h2>Expert</h2>
                            <h3> | {{transformDate(message.createdAt)}}</h3>
                          </div>
                          <div class="triangle"></div>
                          <div class="message">
                            {{message.message}}
                          </div>
                          <div class="entete">
                            <h2>Verified? {{message.verified}}</h2><br>
                            <button id="verifyBtn" [disabled]="message.verified" (click)="addToVerifyMessageIds(message._id)"><h2>Add to Verify</h2></button>
                            <button id="deleteBtn" (click)="addToDeleteMessageIds(message._id)"><h2>Add to Delete</h2></button>
                            <div *ngIf="!message.verified">
                              <br>
                              <div id="editRow" class="row" style="width:50%; float:left;">
                                <textarea rows="3" style="width:100%;"  [formControl] = "newMessage" placeholder="Type here">Edit Here</textarea>
                                <button id="edit" rows="3" style="width:100%;" (click)="editMessage(message._id)"><h2>EDIT</h2></button>
                              </div>
                              <br><br> <br><br>
                            </div>
                          </div>
                        </li>
                      </div>
                      <div *ngIf="message.role === 'CUSTOMER'">
                        <li class="me">
                          <div class="entete">
                            <h3>{{transformDate(message.createdAt)}} | </h3>
                            <h2>Customer</h2>
                            <span class="status blue"></span>
                          </div>
                          <div class="triangle"></div>
                          <div class="message">
                            {{message.message}}
                          </div>
                          <div class="entete">
                            <h2>Verified? {{message.verified}}</h2><br>
                            <button id="verifyBtn" [disabled]="message.verified" (click)="addToVerifyMessageIds(message._id)"><h2>Add to Verify</h2></button>
                            <button id="deleteBtn" (click)="addToDeleteMessageIds(message._id)"><h2>Add to Delete</h2></button>
                            <div *ngIf="!message.verified ">
                              <br>
                              <div id="editRow" class="row" style="float:right;">
                                <textarea [formControl] = "newMessage" rows="3" style="width:100%;" placeholder="Type here">Edit Here</textarea>
                                <button id="edit"  rows="3" style="width:100%;"  (click)="editMessage(message._id)"><h2>EDIT</h2></button>
                              </div>
                              <br><br> <br><br>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>
                  </ul>
                  <footer>
                    <div class="row">
                      <button  id="btn" style="float: left;background-color: rgb(155, 207, 104);"  (click)="verifyMessages()">VERIFY Selected</button>
                      <button id="btn" style="float: right; background-color: red;" (click)="deleteMessages()">DELETE Selected</button>
                    </div>
                  </footer>
                </main>
              </div>
            </div>
            <!--Add Image-->
            <div class="modal-footer">
              Your communication is not end-to-end encrypted
            </div>
        </ng-template>

      </div>
    </div>
  </div>
</ng-container>
